import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { queryClient as qc } from 'keys/queryClient'
import { getStudentBatteriesProfilesFetch } from 'store/middlewares/assessment.crud'
import { dashbordBackgroundColors, dashbordLabelsColors, ratingColors8, ratingListLabel10, ratingListLabel9, ratingTexts8 } from 'keys/rating'

// שקף 4 — תוצאות הקריאה: אותו מפתח קאש בדיוק כמו RatingBarChart בדשבורד
// אינדקס 1 = גבוה (הטוב ביותר), אינדקס 5 = נמוך מאוד (ראה GOOD_RATING_THRESHOLD בבקנד)
const useSlide4Data = (assessmentFilters) => {
    const { data, isLoading, isError } = useQuery({
        queryKey: [qc.correctWordsPerMinuteDoughnut, assessmentFilters?.semester_and_year],
        queryFn: async () => {
            const { data } = await getStudentBatteriesProfilesFetch({ assessmentFilters, headerFilters: null, testTaker: null })
            console.log('🟢 get_profiles response:', data)
            return data
        }
    })
    return useMemo(() => {
        const tiers = [1, 2, 3, 4, 5].map(index => ({
            index,
            label: ratingListLabel10[index - 1],
            color: ratingColors8[index - 1],
            textColor: ratingTexts8[index - 1],
            labelBg: dashbordLabelsColors[5 - index],
            cardBgColor: dashbordBackgroundColors[5 - index],
            count: data?.[index]?.FLUENCY?.count || 0,
            percentage: data?.[index]?.FLUENCY?.percentage || 0,
        }))

        const totalPerformed = tiers.reduce((sum, t) => sum + t.count, 0)
        const readersCount = tiers[0].count + tiers[1].count
        const strugglingCount = tiers[2].count + tiers[3].count + tiers[4].count

        return {
            tiers,
            totalPerformed,
            readersCount,
            readersPct: totalPerformed ? Math.round((readersCount / totalPerformed) * 100) : 0,
            strugglingCount,
            strugglingPct: totalPerformed ? Math.round((strugglingCount / totalPerformed) * 100) : 0,
            strugglingTiers: tiers.slice(2),
            notPerformedCount: data?.not_performed_count || 0,
            redoCount: data?.redo_count || 0,
            isLoading,
            isError
        }
    }, [data, isLoading, isError])
}

export default useSlide4Data
